import { render, staticRenderFns } from "./TkSelectableList.vue?vue&type=template&id=06c18072&scoped=true&"
import script from "./TkSelectableList.vue?vue&type=script&lang=js&"
export * from "./TkSelectableList.vue?vue&type=script&lang=js&"
import style0 from "./TkSelectableList.vue?vue&type=style&index=0&id=06c18072&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c18072",
  null
  
)

export default component.exports